import React, { useEffect, useMemo, useState } from 'react'
import './profile1.css'
import Rating from 'react-rating'
import { Urls } from '../../../../Urls'
import axios from '../../../../Axios'
import Loader from '../../../Loader'
import classes from './Profile.module.css'
import { getImageSrc, imageFallBack } from '../../../../Utility'

const openWebsite = (website) => {
    if (!website) return
    let url = website
    if (url.split('.')[0] === 'www') {
        url = `http://${url}`
    }
    window.open(url, '_blank', 'noopener noreferrer')
}

const Profile = ({ transporter_data }) => {
    const derived = useMemo(() => {
        if (!transporter_data || transporter_data.length === 0) {
            return null
        }
        const blobUrl = transporter_data.attachments?.[0]?.blob_url
        return {
            logo: transporter_data.logo || '',
            website: transporter_data.website || '',
            rawProfileUrl: blobUrl || '#',
            transporter_name: transporter_data.transporter_name ?? ' ',
            company_type: transporter_data.company_type || '',
            headquarter: transporter_data.headquarter || '',
            established: transporter_data.established || '',
            overall_rating: transporter_data.overall_rating ?? 0,
            number_of_ratings: transporter_data.number_of_ratings ?? 0,
            last_updated: transporter_data.last_updated || null,
            shortlistedInitial: transporter_data.shortlisted === 'yes' ? 'yes' : 'no',
            hand_over_status: transporter_data.hand_over_status === true,
            experience_year: transporter_data.experience_year,
        }
    }, [transporter_data])

    const [profileUrl, setProfileUrl] = useState('#')
    const [status] = useState(false)
    const [message] = useState('')

    const rawProfileUrl = derived?.rawProfileUrl ?? '#'

    useEffect(() => {
        if (!rawProfileUrl || rawProfileUrl === '#') {
            setProfileUrl('#')
            return undefined
        }
        let ignore = false
        const body = {
            action: 'download',
            accountName: 'lorrifilesproduction',
            containerName: 'private-container',
            fileName: rawProfileUrl,
        }
        axios.post(Urls.fileService, body)
            .then(res => { if (!ignore) setProfileUrl(res.data.url) })
            .catch(() => { if (!ignore) setProfileUrl('#') })
        return () => { ignore = true }
    }, [rawProfileUrl])

    if (transporter_data === undefined || transporter_data === null) {
        return (
            <div className="container">
                <span className="data_header">Profile Information</span>
                <p>Details not avaialable</p>
            </div>
        )
    }

    if (!derived) {
        return (
            <div className="container">
                <h3 className="data_header">Transporter Details Not Found</h3>
            </div>
        )
    }

    const {
        logo, website, transporter_name, company_type, headquarter, established,
        overall_rating, number_of_ratings, last_updated, hand_over_status, experience_year,
    } = derived

    const showBrochure = profileUrl !== '#'

    return (
        <div className="container Profile_container">
            <div className="card1">
                <div className="card-header1">
                    <img
                        id="profile_logo_screen"
                        alt=""
                        src={getImageSrc(logo)}
                        onError={e => imageFallBack(e)}
                        className="profile-img"
                    />
                </div>
                <div className="card-body1">
                    {hand_over_status ? (
                        <>
                            <span className="full-name">{transporter_name}</span>
                            <i
                                style={{ color: 'green', fontSize: 'x-large' }}
                                data-toggle="tooltip"
                                data-placement="right"
                                title="Profile owned by transporter"
                                className="far fa-check-circle"
                            />
                            <br />
                        </>
                    ) : (
                        <>
                            <span className="full-name">{transporter_name}</span><br />
                        </>
                    )}

                    <div className={classes['count_container']}>
                        <div className={classes['count_holder']}>
                            <Rating
                                emptySymbol="fa fa-star-o fa-2x mystar"
                                fullSymbol="fa fa-star mystar"
                                readonly
                                fractions="4"
                                initialRating={overall_rating}
                            /><br />
                            {number_of_ratings === 0 ? '' : `(${number_of_ratings} Ratings) `}
                        </div>
                    </div>

                    <span className="username">
                        {!website ? (
                            showBrochure && (
                                <a
                                    href="#"
                                    className="username"
                                    data-toggle="modal"
                                    data-target="#profile_brochure_modal"
                                    style={{ textDecoration: 'none', color: '#337ab7' }}
                                >
                                    <i className="fa fa-file-text-o" />  Brochure
                                </a>
                            )
                        ) : (
                            <>
                                <a href="#" onClick={() => openWebsite(website)}>
                                    <i className="fa fa-globe" /> Website
                                </a>
                                {showBrochure && (
                                    <a
                                        href="#"
                                        className="username"
                                        data-toggle="modal"
                                        data-target="#profile_brochure_modal"
                                        style={{ textDecoration: 'none', color: '#337ab7' }}
                                    >
                                        {' | '}<i className="fa fa-file-text-o" />   Brochure
                                    </a>
                                )}
                            </>
                        )}
                    </span><br />

                    <span className="username">
                        {!company_type ? (
                            <>{!established ? '' : `Est. ${established}`}<br /></>
                        ) : (
                            <>
                                {company_type.charAt(0).toUpperCase() + company_type.substring(1)}
                                {' '}
                                {!established ? '' : `| Est. ${established}`}
                                <br />
                            </>
                        )}
                    </span>
                    <span className="username">
                        {!experience_year
                            ? ''
                            : (experience_year === 0
                                ? '1 < Years of experience'
                                : `${experience_year} Years of Experience`)}
                        <br />
                    </span>
                    <span className="username">
                        {!headquarter ? '' : <>HQ: {headquarter} <br /><br /></>}
                    </span>

                    <div className="container">
                        <div>
                            <center>
                                <button
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Find your shortlisted transporters in My Account"
                                    type="button"
                                    id="shortlist"
                                    className="ripple button1"
                                    onClick={() => document.getElementById('Login_to_view_button').click()}
                                >
                                    <i className="fa fa-heart-o" /> Shortlist
                                </button>
                                <button
                                    className="ripple button1"
                                    onClick={() => document.getElementById('Login_to_view_button').click()}
                                >
                                    <i className="fa fa-check-square-o" /> Reference check
                                </button>
                            </center>
                        </div>
                    </div>
                </div>

                <div className="card-footer1 container" style={{ padding: '2%' }}>
                    <div>
                        <center>
                            {last_updated && (
                                <span style={{ fontSize: '14px', fontStyle: 'italic', color: 'lightslategray' }}>
                                    Profile Last Updated on {last_updated}
                                </span>
                            )}
                        </center>
                    </div>
                </div>
            </div>

            <Loader show={status} message={message} />

            <div
                className="modal fade"
                id="profile_brochure_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="profile_brochure_modalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Brochure</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <object
                                aria-label="Transporter brochure"
                                data={`${profileUrl}#view=fit`}
                                type="application/pdf"
                                width="100%"
                                height="550"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile
